<template>
  <el-dialog
    width="50%"
    :title="
      isAdminCheck
        ? isClickNextStepBtn
          ? $t('license.uploadLicenseFile')
          : $t('license.privacyTitle')
        : $t('license.tip')
    "
    :visible.sync="licenseDialogVisible"
    custom-class="license-dialog"
    align="left"
    :modal-append-to-body="true"
    :append-to-body="false"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div :class="{ hasBottom: isClickNextStepBtn }">
      <el-alert
        :title="
          isAdminCheck
            ? !licenseInfo.licenseStatus
              ? $t('license.timeTipProbationary')
              : $t('license.timeTipOffical')
            : !licenseInfo.licenseStatus
            ? $t('license.timeTipnoadminProbationary')
            : $t('license.timeTipnoadminOffical')
        "
        type="error"
        :closable="false"
      >
      </el-alert>
    </div>
    <div class="content" v-if="!isClickNextStepBtn && isAdminCheck">
      <license-agreement></license-agreement>
      <div style="white-space: nowrap; text-align: center">
        <el-checkbox
          name="type"
          v-model="checkValue"
          :true-label="1"
          :false-label="0"
        >
          <span>
            {{ $t("license.license Privacy Agreement") }}
            {{ $t("license.Privacy Agreement") }}
          </span>
        </el-checkbox>
      </div>
    </div>
    <div v-if="isClickNextStepBtn && isAdminCheck">
      <el-upload
        action="fakeaction"
        :on-change="fileUploadChangeLicense"
        :on-remove="fileRemoveChange"
        :auto-upload="false"
        :file-list="uploadLicenseForm.fileList"
        :show-file-list="true"
        :limit="1"
        drag
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          {{ $t("license.dragFile") }}
        </div>
        <div class="el-upload__text">
          {{ $t("license.fileTip") }}
        </div>
      </el-upload>
      <el-progress
        v-if="uploadLicenseForm.startUpload"
        :percentage="uploadLicenseForm.uploadPerc"
        :status="uploadLicenseForm.uploadStatus"
        :stroke-width="3"
      ></el-progress>
    </div>
    <div slot="footer" class="dialog-footer">
      <!-- 按钮使用 v-show 而不使用 v-if的原因是 使用 v-if 确定按钮的禁用在每次返回又重新下一步的时候，一次可禁用一次不可禁用，但是禁用的值都为true-->
      <el-button
        v-show="!isClickNextStepBtn && isAdminCheck"
        size="small"
        type="primary"
        @click="isClickNextStepBtn = true"
        :disabled="!checkValue"
        >{{ $t("button.nextStep") }}
      </el-button>
      <el-button
        v-show="!isClickNextStepBtn"
        size="small"
        @click="handleCloseDialog"
        >{{ $t("button.logoutSystem") }}
      </el-button>
      <el-button
        v-show="isClickNextStepBtn"
        size="small"
        @click="handleBackBtnClick"
        :disabled="!isClickNextStepBtn"
        >{{ $t("button.back") }}
      </el-button>
      <el-button
        v-show="isClickNextStepBtn"
        size="small"
        type="primary"
        :disabled="uploadLicenseForm.disabledUpload"
        @click="uploadLicenseFile"
        >{{ $t("button.confirm") }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import LicenseAgreement from "@/components/license.vue";
import { dataToDay } from "@/utils/utils.js";
import { to } from "await-to-js";
import { initState as globalState } from "@/store/shardActions";

export default {
  components: {
    LicenseAgreement,
  },

  watch: {
    language() {
      this.notChangeshowTip = true;
      this.$nextTick(() => {
        this.createLicense();
      });
    },

    licenseUpdate(newVal) {
      this.$store.commit("config/changeTipsStatus", false);
      this.notChangeshowTip = true;
      if (newVal) {
        this.getLicenseInfo();
        this.$actions.setGlobalState({
          licenseUpdate: false,
        });
      }
    },
  },

  computed: {
    language() {
      return globalState.currentLanguage;
    },

    licenseUpdate() {
      return globalState.licenseUpdate;
    },

    isAdminCheck() {
      return this.$store.state.config.userInfo.domains == "**";
    },

    noShowTips() {
      return this.$store.state.config.noShowTips;
    },
  },

  data() {
    return {
      licenseDialogVisible: false,
      isClickNextStepBtn: false,
      checkValue: 0, // 是否同意协议, 1 为 true， 0 为 flase
      licenseMessageTip: null, // license message instance
      licenseInfo: {},
      notChangeshowTip: false,
      uploadLicenseForm: {
        licFile: "",
        fileList: [],
        disabledUpload: true, // 上传license 文件的确定按钮是否可点击 ，true为不可点击，false 为可点击
        startUpload: "",
        uploadPerc: "",
        uploadStatus: null,
      },
      day: "",
      time: "",
      licenseInstance: null,
    };
  },

  created() {
    this.getLicenseInfo();
  },

  methods: {
    async getLicenseInfo() {
      const [err, res] = await to(this.$httpList.isHaveLicense());
      if (err) {
        return;
      }
      if (res.resultCode == 1001) {
        //正式license,或手动关后不提示
        this.licenseInfo = res.data || {};
        this.createLicense();
      }
    },

    createLicense() {
      if (this.licenseInstance) {
        this.licenseInstance.close();
        this.licenseInstance = null;
      }
      if (this.licenseInfo.permanentAuthorization || this.noShowTips) {
        return;
      }
      let expirationTime =
        new Date(
          dataToDay(this.licenseInfo.expirationTime) + " 00:00:00"
        ).getTime() +
        24 * 60 * 60 * 1000 -
        1;

      if (!(new Date().getTime() < expirationTime)) {
        this.licenseDialogVisible = true;
        return;
      }
      this.time = Math.floor(
        (expirationTime - new Date().valueOf()) / (24 * 3600 * 1000)
      );
      this.day = dataToDay(expirationTime);
     
      const h = this.$createElement;
      const messageContent=h(
            "div",
            {
              style: {
                "box-sizing": "border-box",
                'padding': "0 20px 0 10px",
              },
              class: "global-message-container"
            },
            [
              h("span", { class: "global-message-iconbox" }, [
                h("i", { class: "HSIconfont hs-icon-notification1" }),
              ]),
              h(
                "div",
                {
                  style: {
                    "word-break": "break-all",
                    'color':'#DE5358'
                  },
                },
                this.isAdminCheck
                  ? this.licenseInfo.licenseStatus
                    ? `${this.$t("license.time90Tip", {
                        day: `${this.day}`,
                        time: `${this.time}`,
                      })}`
                    : `${this.$t("license.time30Tip", {
                        day: `${this.day}`,
                        time: `${this.time}`,
                      })}`
                  : this.licenseInfo.licenseStatus
                  ? `${this.$t("license.notAdmintime90Tip", {
                      day: `${this.day}`,
                      time: `${this.time}`,
                    })}`
                  : `${this.$t("license.notAdmintime30Tip", {
                      day: `${this.day}`,
                      time: `${this.time}`,
                    })}`
              ),
            ]
          )
      let instance = this.$createNotice(messageContent, {}, "warning", {
        duration: 0,
        onClose: () => {
          if (this.notChangeshowTip) {
            this.notChangeshowTip = false;
            return;
          }
          this.$store.commit("config/changeTipsStatus", true);
        },
      });
      this.licenseInstance = instance;
    },

    // 文件上传改变license
    fileUploadChangeLicense(licFile) {
      // 判断文件后缀
      let fileName = licFile.name;
      let fileType = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (fileType == "lic") {
        this.uploadLicenseForm.licFile = licFile.raw;
        if (this.uploadLicenseForm.licFile != "") {
          this.uploadLicenseForm.disabledUpload = false;
        }
      } else {
        this.uploadLicenseForm.disabledUpload = true;
      }
    },

    // 文件移除改变的时候
    fileRemoveChange() {
      this.uploadLicenseForm = {
        licFile: "",
        fileList: [],
        disabledUpload: true, // 上传license 文件的确定按钮是否可点击 ，true为不可点击，false 为可点击
        startUpload: "",
        uploadPerc: "",
        uploadStatus: null,
      };
    },

    handleBackBtnClick() {
      this.isClickNextStepBtn = false;
      this.uploadLicenseForm = {
        licFile: "",
        fileList: [],
        disabledUpload: true, // 上传license 文件的确定按钮是否可点击 ，true为不可点击，false 为可点击
        startUpload: "",
        uploadPerc: "",
        uploadStatus: null,
      };
    },
    async uploadLicenseFile() {
      const { licFile } = this.uploadLicenseForm;
      const formData = new FormData();
      formData.append("file", licFile);
      const [err, res] = await to(this.$httpList.getUploadFileSizeLimit());
      if (err) {
        return;
      }
      if (
        res.resultCode == 1001 &&
        licFile.size > Number(res.data.maxPerFileSize)
      ) {
        this.$notify.error({
          message: this.$t("responsePromptMessage.A0408"),
        });
        return;
      }

      //上传文件
      this.uploadLicenseForm.disabledUpload = true;
      this.uploadLicenseForm.uploadPerc = 10;
      this.uploadLicenseForm.startUpload = true;
      let uploadInterval = null;
      let progressInterval = null;
      const [actionErr, actionRes] = await to(
        this.$httpList.getActionId(formData)
      );
      if (actionErr) {
        this.clearIntervalTime(uploadInterval, progressInterval, "exception");
        return;
      }
      if (actionRes.resultCode == 1001) {
        progressInterval = setInterval(() => {
          if (this.uploadLicenseForm.uploadPerc < 90) {
            this.uploadLicenseForm.uploadPerc += 10;
          }
        }, 300);
        uploadInterval = setInterval(async () => {
          const [uploadErr, uploadRes] = await to(
            this.$httpList.uploadLicense(actionRes.data)
          );
          if (uploadErr) {
            return;
          }
          if (uploadRes.resultCode == 1001) {
            switch (uploadRes.data.status) {
              case "UPLOADED":
                this.uploadLicenseForm.uploadPerc = 100;
                this.clearIntervalTime(
                  uploadInterval,
                  progressInterval,
                  "success"
                );
                this.$notify.success({
                  message: this.$t("license.uploadLicenseSuccess"),
                });
                this.$actions.setGlobalState({
                  licenseUpdate: true,
                });
                this.licenseDialogVisible = false;
                break;

              case "UPLOAD_FAILED":
                this.uploadLicenseForm.uploadPerc = 90;
                this.clearIntervalTime(
                  uploadInterval,
                  progressInterval,
                  "exception"
                );
                this.$notify.error({
                  message: uploadRes.data.errMessage
                    ? this.$t(
                        "httpResponsePromptMessage." +
                          uploadRes.data.errMessage.split(":")[0]
                      )
                    : this.$t("httpResponsePromptMessage.A0803"),
                });

                break;
              default:
                break;
            }
          }
        }, 1000);
      }
    },

    handleCloseDialog() {
      this.$store.dispatch("config/logout");
    },

    clearIntervalTime(uploadInterval, progressInterval, status) {
      clearInterval(uploadInterval);
      clearInterval(progressInterval);
      uploadInterval = null;
      progressInterval = null;
      this.uploadLicenseForm.uploadStatus = status;
    },
  },
};
</script>

<style lang="scss">
.hasBottom {
  margin-bottom: 25px;
}

.license-dialog {
  .el-upload {
    width: 100%;
  }
  .el-upload-dragger {
    width: 100%;
  }
  .content {
    margin-top: 10px;
    line-height: 30px;
    height: 350px;
    overflow: auto;
    div {
      margin-bottom: 10px;
    }
  }
  .contentTitle {
    font-weight: 600;
    line-height: 35px;
  }
  .buttonPosition {
    text-align: right;
    margin-right: 20px;
    margin-top: 10px;
  }
  .privacyStyle {
    color: #015ac5;
    font-weight: 600;
    cursor: default;
  }
  .privacyStylehover {
    cursor: pointer;
    white-space: nowrap;
  }
}
</style>
